import { motion } from "framer-motion";
import { Globe, TrendingUp, Fingerprint, Layers, Search } from "lucide-react";
import Reveal from "../Reveal";

const SERVICES = [
  { icon: Globe, title: "Web Development", desc: "High-performance sites and platforms engineered for speed, scale and conversion." },
  { icon: TrendingUp, title: "Performance Marketing", desc: "Full-funnel paid media systems tuned for ruthless ROAS and compounding growth." },
  { icon: Fingerprint, title: "Brand Identity", desc: "Distinctive visual languages and positioning that make brands impossible to ignore." },
  { icon: Layers, title: "UI/UX Engineering", desc: "Kinetic interfaces with obsessive micro-interaction craft and motion systems." },
  { icon: Search, title: "SEO & Growth", desc: "Technical SEO, content engines and analytics that turn search into revenue." },
];

export default function Services() {
  return (
    <section id="services" className="py-28 lg:py-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-volt mb-4">01 / Capabilities</p>
          <h2 className="font-display font-bold tracking-tight text-2xl sm:text-4xl lg:text-5xl max-w-2xl leading-tight">
            Weapons of mass <span className="text-stroke">attention</span>
          </h2>
        </Reveal>
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/5">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.title}
              data-testid={`service-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
              whileHover={{ y: -4 }}
              className={`group relative bg-obsidian p-8 lg:p-10 transition-colors duration-500 hover:bg-panel ${
                i === 4 ? "sm:col-span-2 lg:col-span-1" : ""
              }`}
            >
              <div className="absolute inset-0 border border-transparent group-hover:border-volt/40 transition-colors duration-500 pointer-events-none" />
              <div className="flex items-start justify-between">
                <s.icon size={26} strokeWidth={1.5} className="text-slate-500 group-hover:text-volt transition-colors duration-500" />
                <span className="font-mono text-[10px] tracking-[0.3em] text-slate-600">0{i + 1}</span>
              </div>
              <h3 className="mt-16 font-display font-semibold text-xl sm:text-2xl tracking-tight group-hover:text-volt transition-colors duration-500">
                {s.title}
              </h3>
              <p className="mt-3 text-sm text-slate-400 leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="bg-volt p-8 lg:p-10 flex flex-col justify-between min-h-[240px]"
          >
            <span className="font-mono text-[10px] tracking-[0.3em] text-obsidian/60">YOUR MOVE</span>
            <a href="#contact" data-testid="services-cta" className="font-display font-extrabold text-2xl sm:text-3xl tracking-tight text-obsidian leading-tight hover:underline underline-offset-4">
              Brief us on your next conquest →
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
